import { render } from "./ProductEditComponent.vue?vue&type=template&id=630aaf6e"
import script from "./ProductEditComponent.vue?vue&type=script&lang=js"
export * from "./ProductEditComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__